module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Concluir ou desfazer a finalização de ações de extensão aguardando relatório'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Não há nenhuma ação aguardando relatório',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "folder",
            "color": "brown lighten-1",
            "tooltip": "Concluir"
          },
          on: {
            "click": function($event) {
              return _vm.goConcluirAcao(props.item.idProjeto)
            }
          }
        }), _vm._v(" "), _c('c-tooltip-btn', {
          attrs: {
            "icon": "undo",
            "color": "primary",
            "tooltip": "Desfazer Finalização"
          },
          on: {
            "click": function($event) {
              return _vm.goDesfazerFinalizacao(props.item.idProjeto)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }], null, false, 128512275)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ba0507a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/projetos-concluir-tabela.vue
// module id = 651
// module chunks = 0